var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', {
    attrs: {
      "width": "24",
      "height": "25",
      "viewBox": "0 0 24 25",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M12 0.988281C5.38346 0.988281 0 6.37174 0 12.9883C0 19.6048 5.38346 24.9883 12 24.9883C18.6165 24.9883 24 19.6048 24 12.9883C24 6.37174 18.6165 0.988281 12 0.988281ZM18.7068 9.83039L11.0376 17.4394C10.5865 17.8905 9.86466 17.9206 9.38346 17.4695L5.32331 13.7702C4.8421 13.3191 4.81203 12.5672 5.23308 12.086C5.68421 11.6048 6.43609 11.5747 6.91729 12.0259L10.1353 14.9732L16.9925 8.1161C17.4737 7.6349 18.2256 7.6349 18.7068 8.1161C19.188 8.5973 19.188 9.34918 18.7068 9.83039Z",
      "fill": "currentColor"
    }
  })]);

}
var staticRenderFns = []

export { render, staticRenderFns }